import { css } from "@emotion/css";
import { AppButton, Text } from "components/common";
import { MultiplayerLogoSimple } from "components/icons";
import React from "react";
import { CARD_HEIGHT } from "utils/constants";

const offset = 50;
type Props = {
  handleNext?: VoidFunction;
  index: number;
};
export const StatsStart: React.FC<Props> = ({ handleNext, index }) => {
  return (
    <div
      data-value={index}
      className={css`
        border: 1.825px solid #29282f;
        height: calc(100vh - ${offset}px);
        max-height: calc(${CARD_HEIGHT}px - ${offset}px);
        width: 100%;
        border-radius: 32px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        padding: 150px 24px 65px 24px;
        transition: transform 0.3s;
        position: relative;
        overflow: hidden;
        background-color: #151419;

        &:hover {
          transform: translateY(1px);
        }
      `}
    >
      <MultiplayerLogoSimple />
      <div
        className={css`
          display: flex;
          flex-direction: column;
          align-items: flex-start;
        `}
      >
        <Text.Body style={{ fontSize: "32px" }}>Your Inbox report </Text.Body>
        <Text.Body
          style={{
            fontSize: "14px",
            color: "#A6A6A6",
            marginTop: "10px",
            marginBottom: "50px",
          }}
        >
          An analysis of the last 365 days.
        </Text.Body>
        <AppButton onClick={handleNext}>Start</AppButton>
      </div>

      <div style={{ position: "absolute", top: -10 }}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="375"
          height="390"
          viewBox="0 0 375 390"
          fill="none"
        >
          <g filter="url(#filter0_f_6234_4105)">
            <path
              d="M299.5 289.5H76L148 -163H241L299.5 289.5Z"
              fill="#6A53FE"
              fill-opacity="0.15"
            />
          </g>
          <defs>
            <filter
              id="filter0_f_6234_4105"
              x="-24"
              y="-263"
              width="423.5"
              height="652.5"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="50"
                result="effect1_foregroundBlur_6234_4105"
              />
            </filter>
          </defs>
        </svg>
      </div>
    </div>
  );
};
